export default function Card({
    children,
    className,
    disableHoverEffect = false,
    showHoverEffect,
}) {
    const defaultCss = `bg-white dark:bg-zinc-800/50 border rounded-lg ${
        (disableHoverEffect && 'dark:border-zinc-800') ||
        (showHoverEffect
            ? 'dark:bg-zinc-800 border-zinc-400 dark:border-zinc-500'
            : 'dark:hover:bg-zinc-800 hover:border-zinc-400/80 dark:border-zinc-800 dark:hover:border-zinc-700')
    } transition duration-300`;

    return <div className={`${defaultCss} p-4 ${className}`}>{children}</div>;
}
